import { FormBottomBarWrap } from './create.form-grid-layout.units'
import { createInputFileCsvLocalParser } from './create.input-file.csv-local-parser'
import DecoratorForm, { createDecoratorForm } from './decorator.form'
import FormValidator from './validator'
import createInput from './create.input'
import FormModalWrapper from './modal-wrapper'
import createFormBase from './create.form-base'
import CreateInputFile from './create.input.file'
import CreateDatePicker from './create.date-picker'
import CreateTextEditor from './create.text-editor'
import createColorPicker from './create.color-picker'
import CreateDateExpired from './create.date-expired'
import CreateFormComfirm from './create.form-comfirm'
import createSelectSimple from './create.select-simple'
import createSelectWithApi from './create.select-with-api'
import CreateFormGridLayout from './create.form-grid-layout'
import createInputImageFile from './create.input.image-file'
import CreateAutocompleteChip from './create.autocomplete.chips'

class DinoFormBase {
  //#region Base
  ModalWrap = FormModalWrapper
  BottomBarWrap = FormBottomBarWrap
  FormValidator = FormValidator
  validator = FormValidator.initial
  createFormBase = createFormBase
  createFormComfirm = CreateFormComfirm
  createFormGridLayout = CreateFormGridLayout
  DecoratorForm = DecoratorForm
  createDecoratorForm = createDecoratorForm
  //#endregion

  //#region Inputs
  createColorPicker = createColorPicker
  createDateExpired = CreateDateExpired
  createDatePicker = CreateDatePicker
  createAutocompleteChip = CreateAutocompleteChip
  createInputFileCsvLocalParser = createInputFileCsvLocalParser
  createInputFile = CreateInputFile
  createInputImageFile = createInputImageFile
  createInput = createInput
  createSelectSimple = createSelectSimple
  createSelectWithApi = createSelectWithApi
  createTextEditor = CreateTextEditor
  //#endregion
}

const DinoForm = new DinoFormBase()
export default DinoForm
